/*                                                  */
import { FILENAME, HYDRATION_ERROR } from '../../../../constants.js';
import { block, branch, destroy_effect } from '../../reactivity/effects.js';
import { hydrate_next, hydrate_node, hydrating, set_hydrate_node } from '../hydration.js';
import { create_fragment_from_html } from '../reconciler.js';
import { assign_nodes } from '../template.js';
import * as w from '../../warnings.js';
import { hash } from '../../../../utils.js';
import { DEV } from 'esm-env';
import { dev_current_component_function } from '../../runtime.js';
import { get_first_child, get_next_sibling } from '../operations.js';
import { sanitize_location } from '../../dev/location.js';

/**
 *
 *
 *
 */
function check_hash(element, server_hash, value) {
	if (!server_hash || server_hash === hash(String(value ?? ''))) return;

	let location;

	/*               */
	const loc = element.__svelte_meta?.loc;
	if (loc) {
		location = `near ${loc.file}:${loc.line}:${loc.column}`;
	} else if (dev_current_component_function?.[FILENAME]) {
		location = `in ${dev_current_component_function[FILENAME]}`;
	}

	w.hydration_html_changed(sanitize_location(location));
}

/**
 *
 *
 *
 *
 *
 *
 */
export function html(node, get_value, svg, mathml, skip_warning) {
	var anchor = node;

	var value = '';

	/*                             */
	var effect;

	block(() => {
		if (value === (value = get_value() ?? '')) {
			if (hydrating) {
				hydrate_next();
			}
			return;
		}

		if (effect !== undefined) {
			destroy_effect(effect);
			effect = undefined;
		}

		if (value === '') return;

		effect = branch(() => {
			if (hydrating) {
				/*                                                                            */
				/*                                                                               */
				var hash = /*                  */ (hydrate_node).data;
				var next = hydrate_next();
				var last = next;

				while (
					next !== null &&
					(next.nodeType !== 8 || /*                  */ (next).data !== '')
				) {
					last = next;
					next = /*                       */ (get_next_sibling(next));
				}

				if (next === null) {
					w.hydration_mismatch();
					throw HYDRATION_ERROR;
				}

				if (DEV && !skip_warning) {
					check_hash(/*                  */ (next.parentNode), hash, value);
				}

				assign_nodes(hydrate_node, last);
				anchor = set_hydrate_node(next);
				return;
			}

			var html = value + '';
			if (svg) html = `<svg>${html}</svg>`;
			else if (mathml) html = `<math>${html}</math>`;

			/*                                                                                                     */
			/*                                                                                                     */
			/*                                     */
			var node = create_fragment_from_html(html);

			if (svg || mathml) {
				node = /*                  */ (get_first_child(node));
			}

			assign_nodes(
				/*                       */ (get_first_child(node)),
				/*                       */ (node.lastChild)
			);

			if (svg || mathml) {
				while (get_first_child(node)) {
					anchor.before(/*               */ (get_first_child(node)));
				}
			} else {
				anchor.before(node);
			}
		});
	});
}
